import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-564bada8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "auth-form__title" }, "Вход в приложение \"Пионер\"", -1))
const _hoisted_3 = { class: "auth-form__subtitle" }
const _hoisted_4 = {
  key: 0,
  class: "auth-form__error"
}

import { ref, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { initBridge } from "@/api/interceptors";
import { useTgValidation } from "@/use/useTgValidation";


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthFormTg',
  setup(__props) {

const { loginTgData } = useTgValidation();
const router = useRouter();
const route = useRoute();
const userData = ref<any>(null);

const errorMessage = computed(() => {
  return (
    error.value?.response?.data?.error?.message ||
    error.value?.response?.data?.message
  );
});

const subtitle = computed(() => {
  return tg_data.value
    ? "Пожалуйста, ожидайте"
    : "Данный способ авторизации работает только через Telegram";
});

const tg_data = ref<any>(null);
const user = ref<any>(null);
const loading = ref<any>(false);
const error = ref<any>(null);

async function checkTgData() {
  tg_data.value.initData = await initBridge();

  if (tg_data.value.initData) {
    const { score_id } = route.query;

    try {
      error.value = null;
      loading.value = true;

      await loginTgData(tg_data.value.initData, Number(score_id));
      router.push("/");
    } catch (e) {
      error.value = e;

      user.value = null;
    } finally {
      loading.value = false;
    }
  }
}

onMounted(async () => {
  await checkTgData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(subtitle)), 1),
    (error.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_unref(errorMessage)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})